var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "clvr-config" },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "6" } },
                [
                  _c(_setup.KhSelect, {
                    staticClass: "clvr-config__establishment_select",
                    attrs: {
                      label: _setup.$t("clevehr:common-Establishment"),
                      "prepend-icon": "mdi-hospital-building",
                      items: _setup.establishments,
                      "item-value": "id",
                      "item-text": "text",
                    },
                    on: { change: _setup.establishmentChange },
                    model: {
                      value: _setup.configStore.currentEstablishment,
                      callback: function ($$v) {
                        _vm.$set(
                          _setup.configStore,
                          "currentEstablishment",
                          $$v
                        )
                      },
                      expression: "configStore.currentEstablishment",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { col: "6" } },
                [
                  _c(
                    "kh-button",
                    {
                      attrs: {
                        small: "",
                        disabled: _setup.canLoadGlobalConfig,
                      },
                      on: { click: _setup.loadGlobal },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _setup.$t("system:system-config-load_global")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "kh-loading",
                  rawName: "v-kh-loading",
                  value: { loading: _setup.configStore.loading },
                  expression: "{ loading: configStore.loading }",
                },
              ],
            },
            [
              _c("kh-formula", {
                attrs: { schema: _setup.schema, rules: _setup.rules },
                model: {
                  value: _setup.formValues,
                  callback: function ($$v) {
                    _setup.formValues = $$v
                  },
                  expression: "formValues",
                },
              }),
              _vm._v(" "),
              _c(
                _setup.ClvrFloatingCard,
                { attrs: { bottom: "" } },
                [
                  _c(
                    "kh-button",
                    { attrs: { text: "" }, on: { click: _setup.onCancel } },
                    [_vm._v(_vm._s(_setup.$t("clevehr:Cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "kh-button",
                    {
                      attrs: { elevation: 0, color: _setup.ClvrPrimaryColor },
                      on: { click: _setup.save },
                    },
                    [
                      _c("div", { staticClass: "white--text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_setup.$t("clevehr:common-Backup")) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }